// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__4Xhvj","actionsCol":"EnrolledClinics_actionsCol__-nojh"};